import { BASE_URL } from "../constants/global";
import { isV2UploadsEnabled } from "./featureFlags";

export type ImageDerivative =
  | "original"
  | "analysis"
  | "display"
  | "thumbnail";

/**
 * Build an authenticated image URL, preferring v2 derivative endpoints
 * when the v2 feature flag is enabled.
 */
export const getImageUrl = (
  fileName: string,
  derivative: ImageDerivative = "display"
): string => {
  if (isV2UploadsEnabled()) {
    const base = fileName.replace(/\.[^/.]+$/, "");
    return `${BASE_URL}/v2/files/${encodeURIComponent(
      base
    )}?derivative=${derivative}`;
  }
  return `${BASE_URL}/files/${encodeURIComponent(fileName)}`;
};

/**
 * Upload endpoint helper.
 */
export const getImageUploadUrl = (): string =>
  isV2UploadsEnabled() ? `${BASE_URL}/v2/files` : `${BASE_URL}/files`;

/**
 * Cloud analysis endpoint helper.
 */
export const getImageAnalyzeUrl = (): string =>
  isV2UploadsEnabled() ? `${BASE_URL}/v2/analyze` : `${BASE_URL}/files/forward`;
